export default __webpack_public_path__ + "static/Bitrate_Test_11_WDRMODE_0_Indoor_320000-c449170f056f5405ddda14c5a78dac86.avif";